import { render, staticRenderFns } from "./helpDetails.vue?vue&type=template&id=eedbd4a4&scoped=true&"
import script from "./helpDetails.vue?vue&type=script&lang=js&"
export * from "./helpDetails.vue?vue&type=script&lang=js&"
import style0 from "./helpDetails.vue?vue&type=style&index=0&id=eedbd4a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedbd4a4",
  null
  
)

export default component.exports